/*
 * Copyright 1999-2025 Jagex Ltd.
 */
// TODO: move these to JDS
export const Z_INDEX = {
  tooltip: 1,
  topContainer: 1,
  toast: 10
};
